let _ = t => t,
  _t,
  _t2;
import { css } from 'styled-components';
import Breakpoints from '../../constants/Breakpoints';
export const ContainerStyles = css(["--padding-x:24px;padding-left:var(--padding-x);padding-right:var(--padding-x);margin:0 auto;max-width:1330px;width:100%;", ""], Breakpoints.tabletPortrait(_t || (_t = _`
    --padding-x: 12px;
  `)));
export const TableStyles = css(["width:100%;table-layout:fixed;& .collapsed{height:0;visibility:collapse;}thead tr > th:first-child,thead tr > td:first-child,tbody tr > th:first-child,tbody tr > td:first-child,tfoot tr > th:first-child,tfoot tr > td:first-child{text-align:left;width:", ";", "}"], props => props.columns > 0 && `calc(100% / ${props.columns})`, Breakpoints.phoneLarge(_t2 || (_t2 = _`
      width: 150px;
    `)));